import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "p-grid p-m-0" }
const _hoisted_3 = { class: "p-col-4 p-sm-4 p-md-3 p-p-0 p-d-flex p-flex-column" }
const _hoisted_4 = { class: "p-ml-2" }
const _hoisted_5 = { class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0 kn-height-full-vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FabButton = _resolveComponent("FabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Button = _resolveComponent("Button")
  const _component_Tree = _resolveComponent("Tree")
  const _component_KnHint = _resolveComponent("KnHint")
  const _component_FunctionalitiesManagementDetail = _resolveComponent("FunctionalitiesManagementDetail")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.functionalitiesManagement.title')), 1)
          ]),
          end: _withCtx(() => [
            (_ctx.selectedFunctionality)
              ? (_openBlock(), _createBlock(_component_FabButton, {
                  key: 0,
                  icon: "fas fa-plus",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showForm(null, _ctx.selectedFunctionality.id))),
                  "data-test": "new-button"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar",
              "data-test": "progress-bar"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Tree, {
          id: "document-tree",
          scrollHeight: "calc(100vh - 91px)",
          maximizable: "",
          value: _ctx.nodes,
          selectionMode: "single",
          expandedKeys: _ctx.expandedKeys,
          filter: true,
          filterMode: "lenient",
          onNodeSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showForm($event.data, $event.data.parentId))),
          "data-test": "functionality-tree",
          class: "kn-tree kn-column-tree kn-flex p-p-0"
        }, {
          default: _withCtx((slotProps) => [
            _createVNode("div", {
              class: "p-d-flex p-flex-row p-ai-center",
              onMouseover: ($event: any) => (_ctx.buttonsVisible[slotProps.node.id] = true),
              onMouseleave: ($event: any) => (_ctx.buttonsVisible[slotProps.node.id] = false),
              "data-test": 'tree-item-' + slotProps.node.id
            }, [
              _createVNode("span", null, _toDisplayString(slotProps.node.label), 1),
              _withDirectives(_createVNode("div", _hoisted_4, [
                (_ctx.canBeMovedUp(slotProps.node.data))
                  ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      icon: "fa fa-arrow-up",
                      class: "p-button-link p-button-sm p-p-0",
                      onClick: _withModifiers(($event: any) => (_ctx.moveUp(slotProps.node.id)), ["stop"]),
                      "data-test": 'move-up-button-' + slotProps.node.id
                    }, null, 8, ["onClick", "data-test"])), [
                      [
                        _directive_tooltip,
                        _ctx.$t('managers.functionalitiesManagement.moveUp'),
                        void 0,
                        { top: true }
                      ]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.canBeMovedDown(slotProps.node.data))
                  ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      icon: "fa fa-arrow-down",
                      class: "p-button-link p-button-sm p-p-0",
                      onClick: _withModifiers(($event: any) => (_ctx.moveDown(slotProps.node.id)), ["stop"]),
                      "data-test": 'move-down-button-' + slotProps.node.id
                    }, null, 8, ["onClick", "data-test"])), [
                      [
                        _directive_tooltip,
                        _ctx.$t('managers.functionalitiesManagement.moveDown '),
                        void 0,
                        { top: true }
                      ]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.canBeDeleted(slotProps.node))
                  ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      icon: "far fa-trash-alt",
                      class: "p-button-link p-button-sm p-p-0",
                      onClick: _withModifiers(($event: any) => (_ctx.deleteFunctionalityConfirm(slotProps.node.id)), ["stop"]),
                      "data-test": 'delete-button-' + slotProps.node.id
                    }, null, 8, ["onClick", "data-test"])), [
                      [
                        _directive_tooltip,
                        _ctx.$t('common.delete'),
                        void 0,
                        { top: true }
                      ]
                    ])
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, _ctx.buttonsVisible[slotProps.node.id]]
              ])
            ], 40, ["onMouseover", "onMouseleave", "data-test"])
          ]),
          _: 1
        }, 8, ["value", "expandedKeys"])
      ]),
      _createVNode("div", _hoisted_5, [
        (_ctx.showHint)
          ? (_openBlock(), _createBlock(_component_KnHint, {
              key: 0,
              title: 'managers.functionalitiesManagement.title',
              hint: 'managers.functionalitiesManagement.hint',
              "data-test": "functionality-hint"
            }, null, 8, ["title", "hint"]))
          : _createCommentVNode("", true),
        (_ctx.formVisible)
          ? (_openBlock(), _createBlock(_component_FunctionalitiesManagementDetail, {
              key: 1,
              functionality: _ctx.selectedFunctionality,
              parentId: _ctx.functionalityParentId,
              rolesShort: _ctx.rolesShort,
              onTouched: _cache[3] || (_cache[3] = ($event: any) => (_ctx.touched = true)),
              onClose: _ctx.onClose,
              onInserted: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadPage($event)))
            }, null, 8, ["functionality", "parentId", "rolesShort", "onClose"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}